import React from 'react';

import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { EmploymentEntityIndex } from '@funnels/types';

import { StringDisplay, TextInputField } from '../../Fields';
import { EditableViewProps, FunnelViewProps, StringReadOnlyViewProps } from '../types';

interface BusinessNameFunnelViewProps extends EmploymentEntityIndex, FunnelViewProps {
  label?: string;
}
export const BusinessNameFunnelView = (props: BusinessNameFunnelViewProps) => {
  const { label = `Business name`, employmentIndex, ...rest } = props;

  return (
    <TextInputField
      {...rest}
      className={PII_FIELD_MASKING_CLASS}
      name={FIELD_PATHS.EMPLOYMENT_BUSINESS_NAME(employmentIndex)}
      label={label}
      validationFailMessage={`Please fill the business name`}
      isFullWidth
    />
  );
};

export const BusinessNameReadOnlyView = (props: StringReadOnlyViewProps) => (
  <StringDisplay className={PII_FIELD_MASKING_CLASS} title={'Current employer'} value={props.value} shouldMaskValue />
);

interface BusinessNameEditableViewProps extends EditableViewProps, EmploymentEntityIndex {
  label?: string;
}

export const BusinessNameEditableView = (props: BusinessNameEditableViewProps) => {
  const { label = 'Business name', employmentIndex = 0, isDisabled } = props;

  return (
    <TextInputField
      className={PII_FIELD_MASKING_CLASS}
      name={FIELD_PATHS.EMPLOYMENT_BUSINESS_NAME(employmentIndex)}
      label={label}
      validationFailMessage={'Please enter the Business name'}
      isDisabled={isDisabled}
    />
  );
};
